/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'com.atproto.repo.listMissingBlobs'

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 1000 }),
      500,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  blobs: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<RecordBlob>((() => recordBlob) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns a list of missing blobs for the requesting account. Intended to be used in the account migration flow. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

export const $lxm = $nsid

type RecordBlob = {
  $type?: 'com.atproto.repo.listMissingBlobs#recordBlob'
  cid: l.CidString
  recordUri: l.AtUriString
}

export type { RecordBlob }

const recordBlob = /*#__PURE__*/ l.typedObject<RecordBlob>(
  $nsid,
  'recordBlob',
  /*#__PURE__*/ l.object({
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    recordUri: /*#__PURE__*/ l.string({ format: 'at-uri' }),
  }),
)

export { recordBlob }
